import React from 'react';
import { UsageInfo } from './types';

interface RateLimitMessageProps {
  usage: UsageInfo;
  onUpgradeClick: () => void;
}

const RateLimitMessage: React.FC<RateLimitMessageProps> = ({ usage, onUpgradeClick }) => {
  // Calculate time until next reset
  const nextReset = new Date(usage.resetDate);
  const timeUntilReset = nextReset.getTime() - Date.now();
  const minutesUntilReset = Math.ceil(timeUntilReset / (1000 * 60));
  
  return (
    <div className="fixed bottom-20 left-0 right-0 flex justify-center px-4 z-30 lg:left-64">
      <div className="max-w-xl w-full rounded-lg p-6 bg-slate-700 text-slate-100 shadow-lg border border-slate-600">
        <div className="flex flex-col items-center text-center gap-3">
          <div className="flex items-center gap-2">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-5 w-5 text-amber-400" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
                clipRule="evenodd" 
              />
            </svg>
            <div className="text-lg text-amber-400 font-semibold">
              Rate Limit Reached
            </div>
          </div>
          
          <p className="text-slate-200">
            You've reached your {usage.messagesLimit} message{usage.messagesLimit !== 1 ? 's' : ''} per hour limit on the {usage.tier} tier.
          </p>
          
          {usage.tier === 'free' ? (
            <div className="flex flex-col items-center gap-3">
              <p className="text-slate-300">
		You can wait {minutesUntilReset} minute{minutesUntilReset !== 1 ? 's' : ''} for your limit to reset, or upgrade for higher limits starting at just $10/month.
              </p>
              <button
                onClick={onUpgradeClick}
                className="px-6 py-2 bg-emerald-500 text-slate-900 rounded-md hover:bg-emerald-400 transition-colors font-medium shadow-sm"
              >
                Upgrade Now
              </button>
            </div>
          ) : (
            <p className="text-slate-300">
              Your message limit will reset in {minutesUntilReset} minute{minutesUntilReset !== 1 ? 's' : ''}.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RateLimitMessage;
